import axios from 'axios';
import { api } from "@/api";

export default {
  setReports({commit}, data) {
    return new Promise((resolve, reject) => {
      axios.post(`${process.env.VUE_APP_API_URL}/api/reports/ordered-items`, data).then(res => {
        resolve(res.data)
        commit('updateReports', res.data)
      }, error => {
        reject(error)
      })
    })
  },

  /**
   * Получение данных для отчета по продажам
   * @param commit
   * @param type
   * @param data
   * @returns {Promise<unknown>}
   */
  pullReportSelling({commit}, {type, data}) {
    return new Promise((resolve, reject) => {
      axios.post(`${process.env.VUE_APP_API_URL}/api/reports/selling/${type}`, data).then(res => {
        resolve(res.data)
        commit('updateReportsSelling', {type: type, data: res.data})
      }, error => {
        reject(error)
      })
    })
  },

  /**
   * Получение данных для отчета по заказам
   * @param commit
   * @param type
   * @param data
   * @returns {Promise<unknown>}
   */
  pullReportOrders({commit}, {type, data}) {
    return new Promise((resolve, reject) => {
      axios.post(`${process.env.VUE_APP_API_URL}/api/reports/orders/${type}`, data).then(res => {
        resolve(res.data)
        commit('updateReportsOrders', {type: type, data: res.data})
      }, error => {
        reject(error)
      })
    })
  },

  loadNotifications({commit}, page) {
    commit('common/updatePreload', '', {root: true});
    return new Promise((resolve, reject) => {
      axios.get(`${process.env.VUE_APP_API_URL}/api/notifications?page=${page}`).then(res => {
        resolve(res.data);
        commit('updateNotifications', res.data);
        commit('common/updatePreload', '', {root: true});
      }, error => {
        reject(error);
        commit('common/updatePreload', '', {root: true});
      })
    })
  },

  readNotification({commit}, {id, index}) {
    return new Promise((resolve, reject) => {
      axios.get(`${process.env.VUE_APP_API_URL}/api/notifications/${id}/view`).then(res => {
        resolve(res.data);
        commit('updateNotificationsRead', index);
        commit('user/updateUserInfoNotifications', '', {root: true});
      }, error => {
        reject(error);
      })
    })
  },

  createNotification({commit}, data) {
    return new Promise((resolve, reject) => {
      axios.post(`${process.env.VUE_APP_API_URL}/api/notifications/create`, data).then(res => {
        resolve(res.data);
        commit('user/incrementNotification', '', {root: true});
      }, error => {
        reject(error);
      })
    })
  },

  /*Включить режим редактирования для поля*/
  switchOnEditMode({commit}, field) {
    commit('switchOnEditMode', field)
  },

  /* Выключить режим редактирования у поля*/
  switchOffEditMode({commit}) {
    commit('switchOffEditMode')
  },

  toggleEditMode({commit}, field) {
    commit('toggleEditMode', field)
  },

  /*Обновление основной информации дилера*/
  updateDealer({commit, rootGetters}, {id, data}) {
    commit('setLoading', true)
    return new Promise((resolve, reject) => {
      axios.post(`${process.env.VUE_APP_API_URL}/api/dealers/${id}/update-info`, data).then(res => {
        commit('updateDealerInfo', data, {root: true})
        commit('switchOffEditMode')
        commit('setLoading', false)
        resolve(res)
      }, error => {
        commit('switchOffEditMode')
        commit('setLoading', false)
        reject(error)
      })
    })
  },

  getCurrencies({commit}) {
    commit('setLoading', true)
    return new Promise((resolve, reject) => {
      axios.get(`${process.env.VUE_APP_API_URL}/api/currencies`).then(res => {
        commit('setCurrencies', res.data)
        commit('setLoading', false)
        resolve(res.data)
      }, error => {
        commit('setLoading', false)
        reject(error)
      })
    })
  },

  searchCompanies({commit}, query) {
    return new Promise((resolve, reject) => {
      axios.post(`${process.env.VUE_APP_API_URL}/api/dealers-companies/search`, {query}).then(res => {
        resolve(res.data);
      }, error => {
        reject(error);
      })
    })
  },

  /*Создание плательщика*/
  createCompany({commit}, data) {
    return new Promise((resolve, reject) => {
      axios.post(`${process.env.VUE_APP_API_URL}/api/dealers-companies/create`, data).then(res => {
        commit('user/addCompany', data, {root: true})
        resolve(res.data)
      }, error => {
        reject(error)
      })
    })
  },

  /*Обновление юр. лица*/
  updateCompany({commit}, {id, data, index}) {
    return new Promise((resolve, reject) => {
      axios.post(`${process.env.VUE_APP_API_URL}/api/dealers-companies/${id}/update`, data).then(res => {
        resolve(res);
        commit('user/changeCompany', {
          index: index,
          data: data,
        }, {root: true})
      }, error => {
        reject(error)
      })
    })
  },

  removePayers({commit}, {id, index}) {
    return new Promise((resolve, reject) => {
      axios.delete(`${process.env.VUE_APP_API_URL}/api/dealers-companies/${id}`).then(res => {
        commit('user/removeCompany', index, {root: true})
        resolve(res)
      }, error => {
        reject(error)
      })
    })
  },

  // ============Страница "Сотрудники"============
  pullEmployees({commit}) {
    return new Promise((resolve, reject) => {
      axios.get(`${process.env.VUE_APP_API_URL}/api/employees`).then(res => {
        const employees = res.data
        commit('setEmployees', employees)
        commit('setLoading', false)
        resolve(employees)
      }, error => {
        commit('setEmployees', [])
        reject(error)
      })
    })
  },

  /**
   * Добавления опции с пустым значением
   * @param commit
   */
  addEmptyEmployee({commit}) {
    commit('addEmptyEmployee', {id: null, 'name': 'Все менеджеры'});
  },


  deleteEmployee({commit}, body) {
    return new Promise((resolve, reject) => {
      axios.post(`${process.env.VUE_APP_API_URL}/api/employees/${body.id}/delete`, body.data).then(res => {
        resolve(res.data)
      }, error => {
        reject(error)
      })
    })
  },

  /*Добавление нового сотрудника*/
  createEmployee({commit, rootGetters}, data) {
    return new Promise((resolve, reject) => {
      axios.post(`${process.env.VUE_APP_API_URL}/api/employees/create`, data).then(res => {
        resolve(res)
      }, error => {
        reject(error.response.data)
      })
    })
  },

  setEmployeeInfo({commit, rootGetters}, {id, data}) {
    let payload = {...data};
    if (payload.role) {
      payload.role = payload.role.id;
    }

    return new Promise((resolve, reject) => {
      axios.post(`${process.env.VUE_APP_API_URL}/api/employees/${id}/update`, payload).then(res => {
        resolve(res);
        commit('updateEmployeeInfo', {id, data});
      }, error => {
        reject(error)
      })
    })
  },

  updatePermissionEmployee({commit, rootGetters}, {id, permissionData}) {
    commit('setLoadingInPopup', true)
    return new Promise((resolve, reject) => {
      axios.post(`${process.env.VUE_APP_API_URL}/api/employees/${id}/update-permission`, {permissionData}).then(res => {
        commit('switchOffEditMode')
        commit('setLoadingInPopup', false)
        resolve(res)
      }, error => {
        commit('switchOffEditMode')
        commit('setLoadingInPopup', false)
        reject(error)
      })
    })
  },

  selectEmployee({commit}, employee) {
    return new Promise((resolve, reject) => {
      commit('setSelectedEmployee', employee)
      resolve(true)
    })
  },

  unSelectEmployee({commit}) {
    return new Promise((resolve, reject) => {
      commit('setSelectedEmployee', null)
      resolve(true)
    })
  },

  // ============Страница "Дилеры"============
  updateDealerDiscount({commit, rootGetters}, {id, data}) {
    commit('setLoading', true)
    return new Promise((resolve, reject) => {
      axios.post(`${process.env.VUE_APP_API_URL}/api/dealers/${id}/update-discount`, data).then(res => {
        commit('switchOffEditMode')
        commit('setLoading', false)
        resolve(res)
      }, error => {
        commit('switchOffEditMode')
        commit('setLoading', false)
        reject(error)
      })
    })
  },

  /*Изменение скидки дилера*/
  changeDealerDiscount({commit, getters}, {dealerId, newDiscount}) {
    const initDealers = getters.getDealers
    let dealerIndex = initDealers.findIndex(d => d.id === dealerId)
    if (dealerIndex > -1) {
      commit('updateDealer', {
        dealerIndex,
        prop: 'dealer_discont',
        newDiscount: newDiscount
      })
    }
  },

  updateSortMapDealers({commit}, field) {
    commit('updateSortMap', {table: 'dealers', field})
  },

  updateSortMapEmployees({commit}, field) {
    commit('updateSortMap', {table: 'employees', field})
  },
  // ============Страница "Розничные цены"============
  pullMarkups({commit}) {
    return new Promise((resolve, reject) => {
      axios.get(`${process.env.VUE_APP_API_URL}/api/dealers-pricing/list`).then(res => {
        const markups = res.data
        commit('setMarkups', markups)
        resolve(markups)
      }, error => {
        commit('setMarkups', [])
        reject(error)
      })
    })
  },

  saveMarkup({commit}, {modelId, id, charge}) {
    commit('setLoading', true)
    return new Promise((resolve, reject) => {
      axios.post(`${process.env.VUE_APP_API_URL}/api/dealers-pricing/${modelId}/update-markup/${id}`, {charge}).then(res => {
        // commit('changeMarkup', {cell, indexes})
        commit('switchOffEditMode')
        // commit('setLoading', false)
        resolve(true)
      }, error => {
        // commit('changeMarkup', {cell, indexes})
        commit('switchOffEditMode')
        // commit('setLoading', false)
        reject(false)
      })
    })
  },

  saveTotal({commit}, charge) {
    commit('setLoadingInPopup', true)
    return new Promise((resolve, reject) => {
      axios.post(`${process.env.VUE_APP_API_URL}/api/dealers-pricing/set-total-charge`, {charge}).then(res => {
        resolve(res.data)
      }, error => {
        reject(error)
      })
    })
  },

  servicesLoad ({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get(`${process.env.VUE_APP_API_URL}/api/orders/services`).then(res => {
        resolve(res.data);
        commit('updateServices', res.data);
      }, error => {
        reject(error)
      })
    })
  },

  setProfileInvoices({commit}) {
    return new Promise((resolve, reject) => {
      axios.get(`${process.env.VUE_APP_API_URL}/api/dealers/invoices`).then(res => {
        resolve(res.data);
        commit('updateProfileInvoices', res.data);
      }, error => {
        reject(error)
      })
    })
  },

  setProfileShippings({commit}) {
    return new Promise((resolve, reject) => {
      api.methods.dealers.shippings.get().then(res => {
        resolve(res.data);
        commit('updateProfileShippings', res.data);
      }, error => {
        reject(error)
      })
    })
  },

  requestProfileInvoices({commit}, body) {
    return new Promise((resolve, reject) => {
      axios.post(`${process.env.VUE_APP_API_URL}/api/dealers/request-invoices`, body).then(res => {
        resolve(res.data);
      }, error => {
        reject(error)
      })
    })
  },

  requestProfileShippings(_, body) {
    return new Promise((resolve, reject) => {
      api.methods.dealers.request.shipping.post(body).then(
        (res) => {
          resolve(res.data);
        },
        (err) => {
          reject(err);
        }
      );
    });
  },

  setProfileBalance({commit}) {
    return new Promise((resolve, reject) => {
      axios.get(`${process.env.VUE_APP_API_URL}/api/dealers/balance`).then(res => {
        resolve(res.data);
        commit('updateProfileBalance', res.data);
      }, error => {
        reject(error)
      })
    })
  },


  requestProfileBalance({commit}, body) {
    return new Promise((resolve, reject) => {
      axios.post(`${process.env.VUE_APP_API_URL}/api/dealers/request-balance`, body).then(res => {
        resolve(res.data);
      }, error => {
        reject(error)
      })
    })
  },
}
